import { render, staticRenderFns } from "./ProductUnit.vue?vue&type=template&id=7df196a1&scoped=true"
import script from "./ProductUnit.vue?vue&type=script&lang=js"
export * from "./ProductUnit.vue?vue&type=script&lang=js"
import style0 from "./ProductUnit.vue?vue&type=style&index=0&id=7df196a1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df196a1",
  null
  
)

export default component.exports